export default __webpack_public_path__ + "static/35-2d7764d3ec2aad651cda999f08fb12e3.png";